module.exports = __webpack_public_path__ + "static/media/calendar.3dba5f70.svg";